import type { Customer } from "modules/customers";
import type { ObjectWithId } from "utils/ObjectWithId";

export type AisRedirectUrls = {
  cancelUrl: string;
  failureUrl: string;
  successUrl: string;
};

export type Client = ObjectWithId & {
  active: boolean;
  name: string;
  customer?: Pick<Customer, "name" | "id" | "active">;
  secret: string;
  signingKey: string;
  paymentFailureUrl: string | null;
  paymentPendingUrl: string | null;
  paymentSuccessUrl: string | null;
  paymentCancelUrl: string | null;
  aisRedirectUrls?: AisRedirectUrls;
};

export const PROPERTY_ACTIVE = "active";
export const PROPERTY_REDIRECT_SIGNATURE = "redirectSignature";
export const PROPERTY_SECRET = "secret";
